import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import logo from "../../assets/images/ZR.png";
import { useForm } from 'react-hook-form';
import authenticationApi from "../../services/authenticationApi";
import masterApi from "../../services/masterApi";
import "./login.scss";
import { ThreeDotLoader } from "../../components/Loader/Loader";

const Login = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [error, setError] = useState();
  const [viewLoader, setViewLoader] = useState(false);
  const { login, user, setUser, setRolePermissions } = useContext(AuthContext);
  const [keepLoggedIn, setKeepLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirectPath = params.get("redirect");

useEffect(() => {
  if (user) {
    if (redirectPath) {
      navigate(redirectPath, { replace: true });
    } else {
      navigate("/dashboard", { replace: true });
    }
  }
}, [user, navigate, redirectPath]);

  const onSubmit = async (data) => {
    setViewLoader(true);
    try {
      const userData = await authenticationApi.login({ data });
      if (userData?.data?.ok) {
        setUser(userData?.data?.user);
        localStorage.setItem("user", JSON.stringify(userData?.data?.user));
        localStorage.setItem("token", userData?.data?.serviceToken);
        localStorage.setItem("refreshToken", userData?.data?.refreshToken);
        const response = await masterApi.getRoleFunctionalities(userData?.data?.user?.roleId);
        if (response?.data?.ok) {
          setRolePermissions(response?.data?.rolefunctionalities);
          localStorage.setItem("rolePermissions", JSON.stringify(response?.data?.rolefunctionalities));
        }
        // Redirect immediately after login
        if (redirectPath) {
          navigate(redirectPath, { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } else {
        setViewLoader(false);
        setError(userData?.message);
      }
    } catch (error) {
      setViewLoader(false);
      setError('Something went wrong!');
      console.error('Login failed:', error.message);
    }
  };


  return (
    <div className="main-login-area">
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay"></div>
        <div className="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>

        </div>
      </div>
      <div className="auth-page-content d-flex">
        <div className="container pt-5">
          <div className="justify-content-center row h-100 d-flex align-content-center pt-3">
            <div className="col-md-8 col-lg-5 col-xl-4 height-cls">
              <div className="card">
                <div className="p-4 card-body">
                  {viewLoader && <ThreeDotLoader />}
                  <div className="login-box">
                    <div className="login-content-area">
                      <div className="logo-area">
                        <div className="logo-box  d-flex flex-column justify-content-center align-items-center ">
                          <div className="logo-img text-center mb-4">
                            <img src={logo} alt="" />
                          </div>
                          <h5 className="text-center fw-light mb-1">
                            Welcome to <span className="fw-semibold">ZeaRecruit</span> 

                          </h5>
                          <p className="mb-3 text-center">
                            Please enter your details to sign in
                          </p>
                          {/* <div className="logo-heading">Scheduler</div> */}
                        </div>
                      </div>
                      <div className="login-input-area">
                        {/* <h2 className="heading space-between mb-4 text-center">LOGIN</h2> */}

                        <form className="login-form space-between" onSubmit={handleSubmit(onSubmit)}>
                          <div className="row">
                            <div className="col-12 col-md-12 mb-4 position-relative">
                              <label className="form-label" >
                                Email <span className="asterisk danger">*</span>
                              </label>
                              <input {...register('email', {
                                required: true,
                                pattern: {
                                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: "invalid email address"
                                }
                              })}
                                className={`${errors.email ? 'form-control required' : ' form-control'}`}
                                type="text"
                                placeholder="sample@domain.com"
                              />
                            </div>
                            <div className="col-12 col-md-12 mb-4 position-relative">
                              <label className="form-label" >
                                Password <span className="asterisk danger">*</span>
                              </label>
                              <input {...register('password', { required: "Password is required" })}
                                className={`${errors.password ? 'input required form-control' : ' input form-control'}`}
                                type="password"
                                placeholder="******"
                              />
                              {error && <div className="danger">Email or Password is incorrect</div>}
                            </div>
                          </div>


                          <div className="d-flex align-items-center">
                            <button className="btn btn-primary btn-lg" type="submit">
                              {viewLoader && (
                                <div className="loder-wrapper"> 
                                  <span className="loader-icon"></span>
                                </div>
                              )}
                              LOGIN
                            </button>
                            <div className="forgot-password ms-auto">
                              <Link to="/forgotpassword">Forgot password?</Link>
                            </div>
                          </div>
                          <h6 className="my-4 d-flex w-100 justify-content-center center-aligned align-items-center "><span>OR</span></h6>
                          <div className="d-flex justify-content-between align-items-center gap-3">
                            <button className="btn btn-outline-primary w-100">
                          <span className="me-3">
                          <svg id="_18705667301557996990" data-name="18705667301557996990" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
  <path id="Path_657" data-name="Path 657" d="M272,7.031h7.031V.469A.469.469,0,0,0,278.563,0H272Z" transform="translate(-264.031)" fill="#4caf50"/>
  <path id="Path_658" data-name="Path 658" d="M7.031,7.031V0H.469A.469.469,0,0,0,0,.469V7.031Z" fill="#f44336"/>
  <path id="Path_659" data-name="Path 659" d="M7.031,272H0v6.563a.469.469,0,0,0,.469.469H7.031Z" transform="translate(0 -264.031)" fill="#2196f3"/>
  <path id="Path_660" data-name="Path 660" d="M272,272v7.031h6.563a.469.469,0,0,0,.469-.469V272Z" transform="translate(-264.031 -264.031)" fill="#ffc107"/>
</svg>

                            </span> Log in with Microsoft
                            </button>
                          </div>
                        </form>
                        <div className="forgot-area space-between">
                          <div className="keep-login">
                            {/*<input
                  className="dnone-input"
                  id="keeploggedin"
                  type="checkbox"
                  checked={keepLoggedIn}
                  onChange={() => setKeepLoggedIn(!keepLoggedIn)}
                />
                <label htmlFor="keeploggedin" className="keeploggedin-box">
                  Keep me logged in
                </label>*/}
                          </div>

                        </div>
                        {/*<div className="signup-area space-between">
              Don’t have an account? <Link to="/register">SIGN UP</Link>
            </div>*/}
                      </div>
                    </div>
                    {/* <div className="box-right">
          <img src={workshop} alt="" />
        </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
};

export default Login;
